import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  readonly snackBar = inject(MatSnackBar);

  private showMessage(message: string, panelClass: string, duration = 3000) {
    const config: MatSnackBarConfig = {
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: [panelClass],
    };
    this.snackBar.open(message, '✖', config);
  }

  success(message: string) {
    this.showMessage(message, 'snackbar-success');
  }

  warning(message: string) {
    this.showMessage(message, 'snackbar-warning');
  }

  error(message: string) {
    this.showMessage(message, 'snackbar-error');
  }

  info(message: string) {
    this.showMessage(message, 'snackbar-info');
  }
}
